import { render } from "./IapSubscription.vue?vue&type=template&id=1de196d6"
import script from "./IapSubscription.vue?vue&type=script&lang=js"
export * from "./IapSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__